import { createPortal } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { Config } from 'config';
import { Providers } from 'app/providers';
import { AppRoutes } from 'app/app-routes';

const App = () => {
  const isWafEnabled = Config.waf.enabled;

  const captchaElement = isWafEnabled
    ? createPortal(
        <div
          id="modalOverlay"
          className="fixed inset-0 z-[9999] flex hidden items-center justify-center bg-black/60"
        >
          <div
            id="captchaForm"
            className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-4"
          />
        </div>,
        document.body
      )
    : undefined;

  return (
    <BrowserRouter>
      <Providers>
        <AppRoutes />
        {captchaElement}
      </Providers>
    </BrowserRouter>
  );
};

export default App;
